import React from "react";

const SettlementReport = () => {
  const settlementData = [
    {
      date: "2026-06-09",
      cash: 0.0,
      upi: 0.0,
      cards: 0.0,
      other: 0.0,
      returnAmt: 0.0,
      total: 0.0,
    },
    {
      date: "2026-06-10",
      cash: 0.0,
      upi: 0.0,
      cards: 0.0,
      other: 0.0,
      returnAmt: 0.0,
      total: 0.0,
    },
    {
      date: "2026-06-11",
      cash: 0.0,
      upi: 0.0,
      cards: 0.0,
      other: 0.0,
      returnAmt: 0.0,
      total: 0.0,
    },
    {
      date: "2026-06-12",
      cash: 0.0,
      upi: 0.0,
      cards: 0.0,
      other: 0.0,
      returnAmt: 0.0,
      total: 0.0,
    },
    {
      date: "2026-06-13",
      cash: 0.0,
      upi: 0.0,
      cards: 0.0,
      other: 0.0,
      returnAmt: 0.0,
      total: 0.0,
    },
  ];

  return (
    <div className="container-fluid py-3">
      {/* Summary Cards */}
      <div className="row g-3 mb-3">
        <div className="col-md-4">
          <div
            className="text-center text-white fw-bold py-2 rounded shadow"
            style={{ background: "#2e7d32" }}
          >
            Total: &nbsp;127.54
          </div>
        </div>

        <div className="col-md-4">
          <div
            className="text-center text-white fw-bold py-2 rounded shadow"
            style={{ background: "#b04eb0" }}
          >
            Cash: &nbsp;127.54
          </div>
        </div>

        <div className="col-md-4">
          <div
            className="text-center text-white fw-bold py-2 rounded shadow"
            style={{ background: "#303f9f" }}
          >
            UPI Apps: &nbsp;0.00
          </div>
        </div>

        <div className="col-md-4">
          <div
            className="text-center text-white fw-bold py-2 rounded shadow"
            style={{ background: "#c62828" }}
          >
            By Cards: &nbsp;0.00
          </div>
        </div>

        <div className="col-md-4">
          <div
            className="text-center text-white fw-bold py-2 rounded shadow"
            style={{ background: "#2f7f91" }}
          >
            Other/ Balance: &nbsp;0.00
          </div>
        </div>

        <div className="col-md-4">
          <div
            className="text-center text-white fw-bold py-2 rounded shadow"
            style={{ background: "#7b1fa2" }}
          >
            Return: &nbsp;0.00
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="card border-0 shadow-sm">
        <div className="table-responsive">
          <table className="table table-bordered text-center mb-0">
            <thead>
              <tr
                style={{
                  background:
                    "linear-gradient(90deg, #4f63e7 0%, #4662f0 100%)",
                  color: "#fff",
                }}
              >
                <th>Date</th>
                <th>Cash</th>
                <th>UPI</th>
                <th>By Cards</th>
                <th>Other</th>
                <th>Return</th>
                <th>Total</th>
              </tr>
            </thead>

            <tbody>
              {settlementData.map((item, index) => (
                <tr key={index}>
                  <td className="fw-bold">{item.date}</td>
                  <td>{item.cash.toFixed(2)}</td>
                  <td>{item.upi.toFixed(2)}</td>
                  <td>{item.cards.toFixed(2)}</td>
                  <td>{item.other.toFixed(2)}</td>
                  <td>{item.returnAmt.toFixed(2)}</td>
                  <td>{item.total.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SettlementReport;